import React from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import { Webhook } from 'src/actions/integrations/webhook';

type EventsColumnType = {
  item: Webhook;
};

const EventsColumn = ({ item }: EventsColumnType): JSX.Element => {
  const events = item.events ?? [];

  if (!events.length) {
    return <></>;
  }

  return <EventsColumnText data-aid={`${item.id}-events`}>{get(item, 'events', []).join(', ')}</EventsColumnText>;
};

const EventsColumnText = styled.span``;

export default EventsColumn;
